import { SimpleProjectApi } from 'api/SimpleProjectApi';
import { apiClient } from 'container/apiClient';
import { simpleProjectMapper } from 'container/simpleProjectMapper';

export const simpleProjectApi = new SimpleProjectApi(apiClient, simpleProjectMapper);
